import React from "react";
import CountryFieldContainer from "../../ui/layout/page/forms-container/form-item-container/country-field-container";
import DateFieldContainer from "../../ui/layout/page/forms-container/form-item-container/date-field-container";
import InputContainer from "../../ui/layout/page/forms-container/form-item-container/input-container";
import NationalityFieldContainer from "../../ui/layout/page/forms-container/form-item-container/nationality-field-container";
import AddressSelect from "../shared/components/address-select";
import BirthDate from "../shared/components/birth-date";
import Country from "../shared/components/country";
import FirstName from "../shared/components/first-name";
import Gender from "../shared/components/gender";
import LastName from "../shared/components/last-name";
import Nationality from "../shared/components/nationality";
import { Grid } from "@mui/material";
import { PostAddress } from "../../api/commercial/generated-types";

export default function Person({
  firstName,
  lastName,
  birthdate,
  nationality,
  fullStreet,
  address,
  dataPath,
  shrinkFirstNameLabel,
  handleShrinkFirstNameLabel,
  shrinkLastNameLabel,
  handleShrinkLastNameLabel,
}: {
  gender: string;
  firstName: string;
  birthdate: string;
  lastName: string;
  nationality: string;
  fullStreet: string;
  address: PostAddress;
  dataPath: string;
  shrinkFirstNameLabel?: boolean;
  handleShrinkFirstNameLabel?: () => void;
  shrinkLastNameLabel?: boolean;
  handleShrinkLastNameLabel?: () => void;
}): React.JSX.Element {
  return (
    <Grid
      className="scd-container-base"
      container
      size={{ xs: 12 }}
      key={dataPath}
    >
      <Gender dataPath={dataPath} />
      <InputContainer>
        <FirstName
          shrinkFirstNameLabel={shrinkFirstNameLabel}
          onChange={handleShrinkFirstNameLabel}
          dataPath={dataPath}
          value={firstName}
        />
      </InputContainer>
      <InputContainer>
        <LastName
          shrinkLastNameLabel={shrinkLastNameLabel}
          onChange={handleShrinkLastNameLabel}
          dataPath={dataPath}
          value={lastName}
        />
      </InputContainer>
      <NationalityFieldContainer>
        <Nationality dataPath={dataPath} value={nationality} />
      </NationalityFieldContainer>
      <DateFieldContainer>
        <BirthDate dataPath={dataPath} value={birthdate} />
      </DateFieldContainer>
      <AddressSelect
        fullStreet={fullStreet}
        address={address}
        dataPath={dataPath}
      />
      <CountryFieldContainer>
        <Country dataPath={dataPath} value={address.country} />
      </CountryFieldContainer>
    </Grid>
  );
}
